import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneoutstationcabhire() {



  const cardData =
  {
    keyword: ' Pune Outstation Cab Hire',
    heading: 'Sai Trupti Cabs: Pune Outstation Cab Hire',
    headingDescription: 'Sai Trupti Cabs offers reliable and comfortable Pune out-station cab hire services, designed to make your long-distance journeys smooth and stress-free. Our fleet includes well-maintained, air-conditioned Sedans, SUVs, and Premium vehicles — all equipped with clean interiors and ample luggage space. Every journey is driven by a professional, background-verified chauffeur who ensures punctual pickup in Pune, courteous service, and safe, smooth driving throughout your route. With transparent one-way or round-trip fares, flexible booking options that fit your schedule, and 24 × 7 customer support, Sai Trupti Cabs makes your out-station travel from Pune convenient, affordable and worry-free.',

    top: 'Top Places to Visit in Pune Outstation with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Lonavala",
    "description": "Lonavala, just 65 km from Pune, is a lush green hill station nestled in the Sahyadri ranges. Famous for its misty mountains, cascading waterfalls, and the sweet aroma of chikki in every corner, it’s the most popular weekend escape for Punekars. Tourists love visiting Tiger’s Leap, Bhushi Dam, and Lion’s Point for breathtaking valley views. The drive from Pune to Lonavala through tunnels and ghats is itself a scenic delight. Whether you’re seeking monsoon treks or cozy evenings by the fog, Lonavala offers pure mountain magic and rejuvenation."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Mahabaleshwar, located 120 km from Pune, is a high-altitude paradise blanketed by evergreen forests, strawberry farms, and endless viewpoints. Arthur’s Seat, Elephant’s Head, and Wilson Point offer mesmerizing views of the Western Ghats. Venna Lake invites you for peaceful boating while Mapro Garden tempts you with fresh fruit crushes and chocolates. The cool mountain breeze and British-era charm make Mahabaleshwar a timeless retreat for couples and families alike. From sunrise to sunset, the town radiates calm, romance, and nature’s finest hues."
  },
  {
    "title": "Lavasa",
    "description": "Lavasa, India’s first planned hill city, lies 60 km from Pune and blends European elegance with natural tranquility. Its pastel-colored buildings, cobblestone streets, and waterfront cafés give it a Mediterranean feel. Built along Warasgaon Lake, Lavasa offers kayaking, jet skiing, cycling, and lakeside walks under drifting clouds. The Lakeside Promenade is perfect for capturing sunset reflections and enjoying local Goan cuisine. Whether you visit for leisure or photography, Lavasa enchants visitors with its modern charm and serene mountain vibes."
  },
  {
    "title": "Panchgani",
    "description": "Panchgani, meaning ‘land of five hills,’ is a serene plateau town 100 km from Pune known for its panoramic views and colonial-era charm. The Table Land, Asia’s second-largest volcanic plateau, offers sweeping sights of valleys and sunsets. Strawberry farms, paragliding, and horseback rides add color to the experience. Parsi Point and Sydney Point are ideal spots to soak in the beauty of the Krishna River. The cool climate, peaceful roads, and old-world charm make Panchgani a refreshing getaway for travelers seeking relaxation and fresh air."
  },
  {
    "title": "Matheran",
    "description": "Matheran, around 120 km from Pune, is India’s smallest hill station — and uniquely, completely vehicle-free. Visitors either hike up or take the narrow-gauge toy train through forested slopes. The red-soil paths, British-era bungalows, and over 30 viewpoints including Panorama Point and Echo Point make it a nature lover’s haven. The peaceful silence broken only by birds and wind offers a rare escape from city noise. Horse rides, old cottages, and misty hills give Matheran its quaint, timeless appeal."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, located about 140 km from Pune, is the coastal gem of Maharashtra known for its pristine beaches, historic forts, and relaxed seaside vibe. From sun-soaked Kashid Beach to the picturesque Kolaba Fort accessible during low tide, every corner blends heritage and leisure. The air carries the fragrance of the sea and local Konkani seafood delicacies. Tourists love beach walks, water sports, and ferry rides. Alibaug’s tranquil coastline, coconut groves, and breezy charm make it a perfect outstation destination for weekend rejuvenation."
  },
  {
    "title": "Bhimashankar",
    "description": "Bhimashankar, about 110 km from Pune, is both a sacred pilgrimage site and a nature reserve. Home to one of the 12 Jyotirlingas of Lord Shiva, the temple rests amid dense forests of the Western Ghats. The Bhimashankar Wildlife Sanctuary surrounding it shelters the rare Indian Giant Squirrel and countless bird species. The trek through waterfalls and misty trails is equally exhilarating for adventurers. Whether you visit for faith or for forest serenity, Bhimashankar rejuvenates both soul and spirit."
  },
  {
    "title": "Nashik",
    "description": "Nashik, 210 km from Pune, is a unique blend of spirituality and sophistication — home to the sacred Godavari River and India’s finest vineyards. Trimbakeshwar Temple attracts devotees, while Sula Vineyards offers wine tastings among lush green estates. The city hosts the Kumbh Mela every 12 years, drawing millions of pilgrims. Nashik’s calm ghats, scenic hills, and luxurious resorts make it perfect for both religious journeys and romantic vineyard getaways. It’s a destination that nourishes both faith and leisure."
  },
  {
    "title": "Shirdi",
    "description": "Shirdi, around 185 km from Pune, is a sacred town synonymous with the life and teachings of Shri Sai Baba. Devotees from all over India visit the Sai Baba Samadhi Temple to seek blessings and peace. The spiritual energy here is palpable, especially during aarti when chants fill the air with devotion. Beyond religion, Shirdi’s clean, organized environment and nearby attractions like Shani Shingnapur make it a fulfilling day-trip from Pune. Every visitor leaves with serenity and renewed faith."
  },
  {
    "title": "Khandala",
    "description": "Khandala, located just beyond Lonavala, is a romantic hill station famous for its mist-covered cliffs and scenic viewpoints like Duke’s Nose and Rajmachi Point. The lush valleys and seasonal waterfalls create a postcard-perfect setting, especially during monsoon. The drive from Pune to Khandala along the Mumbai–Pune Expressway offers breathtaking panoramas of tunnels, mountains, and clouds. Ideal for trekking, photography, and long drives, Khandala offers a peaceful blend of adventure and tranquility — the quintessential escape close to Pune."
  }
],



   "services": [
    {
      "name": "Pune Outstation Cab Hire",
      "description": "Book reliable Pune Outstation Cab Hire for your long-distance travel needs. We offer AC and Non-AC cabs, professional chauffeurs, and well-maintained vehicles for smooth intercity rides. Whether you’re planning a weekend getaway, business trip, or family vacation, our outstation service ensures comfort, safety, and punctuality. Enjoy doorstep pickup, flexible routes, and transparent fares for a worry-free journey."
    },
    {
      "name": "Outstation Taxi Service Pune",
      "description": "Our Outstation Taxi Service in Pune is designed for convenient and comfortable intercity travel. Choose from a wide range of vehicles including Sedans, Ertiga, and Innova for trips to Mumbai, Mahabaleshwar, Lonavala, Shirdi, and more. With trained drivers, on-time pickups, and 24x7 support, we guarantee a pleasant travel experience. Ideal for families, corporate clients, and tourists."
    },
    {
      "name": "Pune Outstation Car Hire",
      "description": "Hire an outstation car from Pune for flexible travel to any destination across Maharashtra and beyond. Our service includes AC/Non-AC options, courteous drivers, and clean vehicles with ample luggage space. Enjoy one-way or round-trip rides with easy online booking, real-time updates, and transparent pricing. Perfect for leisure trips, pilgrimages, or corporate travel."
    },
    {
      "name": "Pune AC Outstation Cab",
      "description": "Experience cool and comfortable long-distance travel with our Pune AC Outstation Cab service. Our air-conditioned cars ensure a relaxing ride, even during hot summer journeys. Each cab comes with professional drivers, flexible pickup times, and route customization options. Ideal for family tours, business meetings, and weekend getaways."
    },
    {
      "name": "Pune Non AC Outstation Cab",
      "description": "If you’re looking for budget-friendly travel, our Non-AC Outstation Cab Service in Pune offers affordable rates without compromising on comfort. Enjoy safe rides in clean, well-maintained vehicles with courteous drivers. Suitable for students, groups, and travelers who prefer economical options for long-distance journeys."
    },
    {
      "name": "Luxury Outstation Cab Pune",
      "description": "Travel in style with our Luxury Outstation Cab Service from Pune. Choose from premium vehicles like Innova Crysta, Fortuner, and sedans offering plush interiors, AC comfort, and professional chauffeurs. Ideal for VIP guests, business executives, and wedding events. We ensure privacy, comfort, and top-tier service throughout your journey."
    },
    {
      "name": "Pune Innova Outstation Cab",
      "description": "Hire a spacious Innova for your Pune Outstation trips. Our 7-seater AC/Non-AC Innovas are perfect for family vacations, group outings, and corporate travel. With ample luggage space, professional drivers, and flexible booking options, you can enjoy a relaxed and hassle-free trip to destinations like Goa, Mahabaleshwar, and Mumbai."
    },
    {
      "name": "Pune Ertiga Outstation Cab",
      "description": "Book an Ertiga Outstation Cab from Pune for comfortable group or family travel. Our Ertigas are equipped with AC, clean interiors, and experienced drivers for smooth intercity rides. Enjoy cost-effective pricing, real-time booking confirmation, and 24x7 availability for popular destinations like Nashik, Shirdi, and Lonavala."
    },
    {
      "name": "Affordable Outstation Cab Pune",
      "description": "Enjoy budget-friendly Pune Outstation Cab services with no hidden charges. We provide AC/Non-AC options, skilled drivers, and transparent billing. Whether for leisure, business, or temple visits, our service guarantees safe, punctual, and economical travel for every customer."
    },
    {
      "name": "Pune Outstation One Way Cab",
      "description": "Hire a one-way outstation cab from Pune and pay only for the distance you travel. Perfect for travelers heading to destinations like Mumbai, Kolhapur, or Nagpur. Get AC/Non-AC options, professional drivers, online tracking, and instant booking confirmation. Ideal for airport drops, family relocations, or single-way travel plans."
    },
    {
      "name": "Pune Outstation Drop Cab",
      "description": "Book Pune Outstation Drop Cab service for convenient one-way intercity travel. Get dropped off safely at your destination with punctual drivers and clean vehicles. Perfect for travelers who need quick and safe transfers from Pune to nearby cities or towns."
    },
    {
      "name": "Corporate Outstation Cab Pune",
      "description": "Our Corporate Outstation Cab Service in Pune is tailored for business travelers and company executives. We provide punctual, reliable, and comfortable travel for client meetings, conferences, or airport transfers. Enjoy easy billing, professional chauffeurs, and luxury cars for a premium experience."
    },
    {
      "name": "Wedding Outstation Cab Pune",
      "description": "Make wedding travel elegant with our Outstation Wedding Cab Service in Pune. We provide luxury sedans, SUVs, and MPVs for guests and family members with on-time pickups, professional drivers, and beautifully maintained vehicles. Ideal for out-of-town weddings and related events."
    },
    {
      "name": "Online Outstation Cab Pune",
      "description": "Book your Outstation Cab in Pune online within minutes. Enjoy a user-friendly interface, secure payments, and instant confirmation. Choose from multiple car options like Ertiga, Innova, and Sedans with AC/Non-AC availability. 24x7 customer support ensures smooth booking and travel assistance throughout your trip."
    },
    {
      "name": "Best Outstation Cab Pune",
      "description": "Choose the Best Outstation Cab Service in Pune for reliability, comfort, and customer satisfaction. With a fleet of well-maintained vehicles, professional drivers, flexible travel plans, and transparent pricing, we are your trusted partner for all intercity travel needs across Maharashtra and beyond."
    }
  ],
  "tableData": [
    ["Pune Outstation Cab Hire", "Outstation Taxi Service Pune"],
    ["Pune Outstation Car Hire", "Pune AC Outstation Cab"],
    ["Pune Non AC Outstation Cab", "Luxury Outstation Cab Pune"],
    ["Pune Innova Outstation Cab", "Pune Ertiga Outstation Cab"],
    ["Affordable Outstation Cab Pune", "Pune Outstation One Way Cab"],
    ["Pune Outstation Drop Cab", "Corporate Outstation Cab Pune"],
    ["Wedding Outstation Cab Pune", "Online Outstation Cab Pune"],
    ["Best Outstation Cab Pune", ""]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune Outstation Cab Hire",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable outstation cab services from Pune — ideal for leisure trips, business travel, and long-distance journeys."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Enjoy clear, affordable pricing for Pune outstation cab services with no hidden charges, ensuring a hassle-free travel experience."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, or Tempo Travellers to match your group size, luggage, and comfort preferences for long-distance trips."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our courteous and skilled drivers are familiar with routes from Pune to nearby cities and tourist destinations, ensuring a safe and timely journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup & Drop Locations",
    "WhyChoosedescription": "We provide convenient pickups from anywhere in Pune and drop-offs at any location across your chosen outstation destination."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All vehicles are regularly serviced, sanitized, and maintained to ensure comfort and reliability throughout your outstation journey."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, route planning, and any travel-related queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Pune outstation cab easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]





























  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pune outstation cab hire services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable outstation cab hire services from Pune to various cities and tourist destinations across Maharashtra and India.',
  },
  {
    question: 'How can I book an outstation cab from Pune with Sai Trupti Cabs?',
    answer: 'You can easily book your Pune outstation cab through our website, mobile app, or by contacting our 24×7 customer support team for instant booking and confirmation.',
  },
  {
    question: 'What types of cabs are available for Pune outstation trips?',
    answer: 'We offer hatchbacks, sedans, SUVs, Ertiga, Innova Crysta, Urbania, and Tempo Travellers to accommodate solo travelers, families, and larger groups.',
  },
  {
    question: 'Are the drivers experienced for Pune outstation cab trips?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in long-distance travel, ensuring a safe and comfortable journey from Pune.',
  },
  {
    question: 'Can I hire an outstation cab from Pune for family, corporate, or group trips?',
    answer: 'Certainly. Our outstation cab services cater to family vacations, corporate trips, group tours, pilgrimages, and airport transfers.',
  },
  {
    question: 'Is the Pune outstation cab hire service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 outstation cab services from Pune, allowing you to plan your trip at any time for convenience and flexibility.',
  },
  {
    question: 'What are the fares for Pune outstation cab services?',
    answer: 'Outstation cab fares from Pune start from approximately ₹1,200 for sedans and ₹1,800–₹3,500 for SUVs and larger vehicles, depending on vehicle type, distance, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Pune outstation cab bookings?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene protocols are followed for Pune outstation cabs?',
    answer: 'All vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene measures to ensure a secure and comfortable journey.',
  },
  {
    question: 'Is customer support available during Pune outstation cab trips?',
    answer: 'Yes, our dedicated 24×7 customer support team is available to assist you before, during, and after your Pune outstation cab journey.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Booking an outstation cab from Pune with Sai Trupti Cabs was smooth and reliable. The driver was punctual and the ride very comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Patil',
    feedback: 'Excellent Pune outstation cab service. The vehicle was clean and spacious, and the driver was courteous and professional.',
    rating: 5,
  },
];















































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];
















const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Outstation Cab Hire",
  "image": "https://saitrupticabs.com/assets/images/pune-outstation-cab.jpg",
  "description": "Book Pune outstation cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Affordable and reliable online cab booking 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1420"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pune-outstation-cab-hire"
  }
};



  return (
    <div>
      <Helmet>
  <title>Pune Outstation Cab Hire | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pune outstation cabs with Sai Trupti Cabs. Choose AC, Non-AC, luxury rides, Innova or Ertiga for one-way trips, round trips, corporate travel, weddings, or outstation trips. Affordable and reliable online cab booking 24x7." 
  />
  <meta 
    name="keywords" 
    content="Pune Outstation Cab Hire, Outstation Taxi Service Pune, Pune Outstation Car Hire, Pune AC Outstation Cab, Pune Non AC Outstation Cab, Luxury Outstation Cab Pune, Pune Innova Outstation Cab, Pune Ertiga Outstation Cab, Affordable Outstation Cab Pune, Pune Outstation One Way Cab, Pune Outstation Drop Cab, Corporate Outstation Cab Pune, Wedding Outstation Cab Pune, Online Outstation Cab Pune, Best Outstation Cab Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/30.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneoutstationcabhire;